import axios from 'axios'

export let fetchOrders = async ({offset, limit, filterData}) => {
  let res = await axios.post('orders', {
    limit: limit,
    offset: offset,
    filterData: filterData
  })

  return res.data
}

export let fetchCloseDocs = async () => {
  let res = await axios.get('orders/close-docs')

  return res.data
}

export let payLc = async ({orderId}) => {
  let res = await axios.post('pay/lc', {
    ORDER_ID: orderId
  })

  return res.data
}



// WEBPACK FOOTER //
// ./src/api/orders.js